import React, { ReactElement } from 'react';
import { Card, Placeholder } from 'react-bootstrap';
import { priceSplitter } from '../../../utils/helpers/NumberFormater';

interface ControllingCard {
    cardName: string;
    icon: ReactElement;
    baseColor: string;
    total: number;
    styleCard?: string;
    withoutFormating?: boolean;
    isLoading?: boolean;
}

export function ControllingCard({
    cardName,
    icon,
    baseColor,
    total,
    styleCard = '',
    withoutFormating,
    isLoading = false,
}: ControllingCard) {
    const renderValue = () => {
        if (isLoading) {
            return (
                <Placeholder as="span" animation="glow">
                    <Placeholder className="skeleton" style={{ width: 90 }} />
                </Placeholder>
            );
        }
        return withoutFormating ? total : `${priceSplitter(total ?? 0)} €`;
    };

    return (
        <div className="col-xl-4 col-md-6 col-sm-12">
            <Card className={`shadow-sm border-0 ${styleCard}`}>
                <Card.Body className="p-3">
                    <div className="d-flex justify-content-between align-items-start">
                        <div>
                            <div className="text-uppercase">{cardName}</div>
                            <div className="h6 fw-bold">{renderValue()}</div>
                        </div>
                        <div
                            className={`d-flex align-items-center justify-content-center rounded-circle bg-${baseColor} text-white`}
                            style={{ width: '40px', height: '40px' }}
                        >
                            {icon}
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </div>
    );
}
